import styled from 'styled-components';

import Accordion from './accordion';

const TextBox = styled.div`
  font-size: 16px;
  white-space: pre-wrap;
`;

type AccordionItemProperties = {
  itemIndex: number;
  openAccordions: Array<number>;
  title: string;
  content: Array<string> | string;
};

const AccordionItem = ({ itemIndex, openAccordions, title, content }: AccordionItemProperties) => {
  const formattedContent = Array.isArray(content)
    ? content.map((item, index, array) => (
        <div key={item}>
          <p>{item}</p>
          {Number(index) === array.length - 1 ? null : <br />}
        </div>
      ))
    : content;

  return (
    <Accordion show={openAccordions.includes(itemIndex)} title={title} isBlueHeading={true}>
      <TextBox className='pad-bottom-md pad-right-lg'>{formattedContent}</TextBox>
    </Accordion>
  );
};

export default AccordionItem;
